import React, { useState } from 'react';
import { useBlocker } from 'react-router-dom';
import {
  Modal,
  TFVButton,
  Translate,
  RouteLeavingModal,
} from '../../components';

import './style.scss';

const RouteLeavingGuard = ({
  when = true, // Default to blocking navigation
  shouldBlockNavigation = () => true, // Default function that always blocks
  onShowModal = () => {},
  onCloseModal = () => {},
  onConfirm = () => {},
  navigate = () => {},
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const showModal = location => {
    onShowModal();
    setModalVisible(true);
    setNextLocation(location);
  };

  const closeModal = callback => {
    onCloseModal();
    setModalVisible(false);
    if (callback) {
      callback();
    }
  };

  const handleBlockedNavigation = tx => {
    if (!confirmedNavigation && shouldBlockNavigation(tx.location)) {
      showModal(tx.location);
      return false; // Block navigation
    }
    return true; // Allow navigation
  };

  const handleConfirmNavigationClick = () => {
    onConfirm();
    closeModal(() => {
      if (nextLocation) {
        setConfirmedNavigation(true);
        // Do NOT call blocker.proceed() here! Let useEffect handle it.
      }
    });
  };

  const blocker = useBlocker(({ nextLocation, historyAction }) => {
    if (!when) return false;

    const shouldBlock = handleBlockedNavigation({
      location: nextLocation,
      action: historyAction,
    });

    return !shouldBlock;
  });

  React.useEffect(() => {
    if (confirmedNavigation && blocker.state === 'blocked') {
      blocker.proceed();
    }
  }, [confirmedNavigation, blocker]);

  return (
    <RouteLeavingModal
      isVisible={modalVisible}
      onCloseClicked={() => closeModal()}
      onOverlayClick={() => closeModal()}
      onConfirmClick={() => handleConfirmNavigationClick()}
      message={Translate({ content: 'RouteLeavingGuard.cancelMessage' })}
    />
  );
};

export default RouteLeavingGuard;
